import { useEffect } from 'react'

/**
 * On a page whose address or code is the credential, nothing it loads from
 * elsewhere (the anti-bot script) should be told where the visitor came from,
 * not even by the Referer header.
 */
export function useNoReferrer(): void {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'referrer'
    meta.content = 'no-referrer'
    document.head.appendChild(meta)
    return () => meta.remove()
  }, [])
}
